import Link from "next/link";
import { useRouter } from "next/router";

interface Props {
  basePath: string;
  currentPage?: number;
  totalPage?: number;
}

export default function Pagination({
  basePath,
  currentPage = 0,
  totalPage = 0
}: Props) {
  const router = useRouter();

  if (totalPage <= 1) {
    return null;
  }

  const locale = router.locale;

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination">
        <li className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}>
          <Link
            href={`${basePath}${
              currentPage > 2 ? "?page=" + (currentPage - 1) : ""
            }`}
            className="page-link shadow-none"
            locale={locale}
          >
            Prev
          </Link>
        </li>
        <li
          className={`page-item ${currentPage === totalPage ? "disabled" : ""}`}
        >
          <Link
            href={`${basePath}?page=${currentPage + 1}`}
            className="page-link shadow-none"
            locale={locale}
          >
            Next
          </Link>
        </li>
      </ul>
    </nav>
  );
}
